// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3sIBv","label":"Labeled_label__32fh0","divider":"Labeled_divider__1Dss9"};